import type { CSSProperties, ReactNode } from 'react';

interface SegmentedOption<T> { value: T; label: ReactNode; testId?: string; title?: string }

/**
 * A row of toggle buttons where one is pressed (aria-pressed). Each place keeps its own semantics:
 * `role` and `aria-label` on the row, `buttonRole` (e.g. tab) and `buttonType` on the buttons.
 */
export function Segmented<T extends string | number | boolean>({ options, value, onChange, role, label, style, buttonRole, buttonType }: {
  options: Array<SegmentedOption<T>>; value: T; onChange: (v: T) => void;
  role?: string; label?: string; style?: CSSProperties; buttonRole?: string; buttonType?: 'button';
}) {
  return (
    <div className="segmented" role={role} aria-label={label} style={style}>
      {options.map((o) => (
        <button key={String(o.value)} type={buttonType} role={buttonRole} aria-pressed={value === o.value} onClick={() => onChange(o.value)} data-testid={o.testId} title={o.title}>{o.label}</button>
      ))}
    </div>
  );
}
